import { Col, Container, Grid } from "@components/layout/Grid"
import { cn } from "@utils/tw"
import { defineBlock } from "eddev/blocks"
import { dynamic } from "eddev/dynamic"
import { ComponentPropsWithoutRef, forwardRef } from "react"

export const meta: BlockMeta = {
  title: "Gravity form",
  category: "common",
  icon: "forms",
  keywords: ["page"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
    multiple: false,
  },
}

/**
 * Loaded dynamically when needed, since the form components are quite heavy.
 */
const GravityForm = dynamic(() => import("@components/forms/organisms/GravityForm"), "GravityForm")

export default defineBlock("forms/gravity-form", (props) => {
  return (
    <FormContainer>
      <div className="grid-auto">
        <div className="col-span-12 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3">
          {props.selectForm && <GravityForm form={props.selectForm} />}
        </div>
      </div>
    </FormContainer>
  )
})

const FORM_CONTAINER_CLASSES = [
  "my-6",
  "[&_.form-row]:flex [&_.form-row]:gap-5",
  "[&_.form-row_.form-row-item]:flex-[1_1_auto] [&_.form-row_.form-row-item]:w-[calc(100%*var(--field-columns))]",
  "[&_.form-row_.form-row-item_input[type='checkbox']]:hidden [&_.form-row_.form-row-item_input[type='radio']]:hidden",
  "[&_.form-row_.form-row-item_.checkbox-group]:flex [&_.form-row_.form-row-item_.checkbox-group]:flex-wrap [&_.form-row_.form-row-item_.checkbox-group]:gap-x-6 [&_.form-row_.form-row-item_.checkbox-group]:gap-y-2",
  "[&_.form-row_.form-row-item_.radio-group]:flex [&_.form-row_.form-row-item_.radio-group]:flex-wrap [&_.form-row_.form-row-item_.radio-group]:gap-x-6 [&_.form-row_.form-row-item_.radio-group]:gap-y-2",
  "[&_footer]:mt-6",
]

const FormContainer = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<typeof Container>>(
  ({ className, ...props }, ref) => (
    <Container ref={ref} className={cn(FORM_CONTAINER_CLASSES, className)} {...props} />
  ),
)
FormContainer.displayName = "FormContainer"
